import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import FetchLogin from "../components/Fetch/FetchLogin";

export default function AgentAccept() {
	const user = useSelector((state) => state.login.user);
	const token = useSelector((state) => state.login.token);
	const hist = useHistory();
	const [v, setV] = React.useState({
		lvl: 1,
		tier_target: "S$0",
		tier_reward: "0%",
		sale_target: "S$0",
		sale_reward: "S$0",
		agentSumWeek: "S$0",
	});

	const reqReward = FetchLogin("agent-reward", {
		data: { token: token },
		callback: (cb) => {
			if (cb.response.success) {
				setV2({
					tier_target: cb.response.data.tier_target,
					tier_reward: cb.response.data.tier_reward,
					sale_target: cb.response.data.sale_target,
					sale_reward: cb.response.data.sale_reward,
					lvl: cb.response.data.lvl,
					agentSumWeek: cb.response.data.agentSumWeek,
				});
			}
		},
	});

	const setV2 = (v2) => {
		setV((prev) => ({ ...prev, ...v2 }));
	};

	useEffect(() => {
		reqReward.handleTrigger();
		// eslint-disable-next-line
	}, []);

	return (
		<MainContainer
			render={
				<Grid container>
					<Grid
						item
						xs={12}
						style={{
							height: 150,
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							paddingBottom: 32,
							borderBottom: "1px solid #ddd",
						}}
					>
						<TopBar
							leftSide="-1"
							title={
								<>
									{user.name}
									<br />
									Agent ID: {user.agent_id}
								</>
							}
						/>
					</Grid>
				</Grid>
			}
		>
			<div className="agent-box-container">
				<span className="agent-box">
					<span>
						Current Level:
						<br />
						<b>{user.agent_lvl}</b>
						<br />
						<b>{user.agenttiername}</b>
					</span>
				</span>
				<span
					className="agent-box"
					style={{ cursor: "pointer" }}
					onClick={() => hist.push("agent/history")}
				>
					<span>
						Value Generated:
						<br />
						<b>S$ {v.agentSumWeek}</b>
					</span>
				</span>
			</div>
			<div className="details">
				<h1>Tier Target</h1>
				<p>
					<b>Level {v.lvl}:</b> Generate at least <b>{v.tier_target}</b> in
					sales per week of 4D & entitled to <b>{v.tier_reward}</b> percentage
					of sales purchase.
				</p>
				<h1>Sales Target</h1>
				<p>
					hit <b>{v.sale_target}</b> in sales of 4D. Receive{" "}
					<b>{v.sale_reward}</b>
				</p>
			</div>
		</MainContainer>
	);
}
